<div class="container-swiper-images" [class.is-single]="images?.length === 1">
    <ng-container *ngIf="images?.length > 1">
        <div class="button-swiper-custom button-prev-custom pointer-in"
            [class.d-md-none]="images.length<=2"
            (click)="swiperImages.swiperRef.slidePrev()"> <i
                class="fa-light fa-chevron-left fa-lg"></i>
        </div>
        <div class="button-swiper-custom button-next-custom pointer-in"
            [class.d-md-none]="images.length<=2"
            (click)="swiperImages.swiperRef.slideNext()"> <i
                class="fa-light fa-chevron-right fa-lg"></i>
        </div>
    </ng-container>

    <swiper #swiperImages class="swiper" [config]="swiperImagesConfig">
        <ng-template class="imagesCards" *ngFor="let item of images; index as i"
            swiperSlide>
            <img fallimg class="img-single-swiper"
                src="{{urlImages}}/{{item.url}}" />
        </ng-template>
    </swiper>
</div>